namespace GeniuzPOS.InitialData {
    export class PsCustomerSurveyPosColumns {
        static columnsKey = 'InitialData.PsCustomerSurveyPos';
    }
}
